import List from './views/List.vue'
import CreateEdit from './views/CreateEdit.vue'
import Get from './views/Get.vue'
import ListDelete from './views/ListDelete.vue'
import Delete from './views/Delete.vue'

export const IncidentRoutes = [
  {
    path: '/incidents',
    name: 'ListIncidents',
    component: List,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'incident:list'
    }
  },
  {
    path: '/incident/',
    name: 'CreateIncident',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'incident:create'
    }
  },
  {
    path: '/incident/:id',
    name: 'UpdateIncident',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'incident:update'
    }
  },
  {
    path: '/incident/view/:id',
    name: 'GetIncident',
    component: Get,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'incident:get'
    }
  },
  {
    path: '/incidents-deletion-request/',
    name: 'ListDeleteIncident',
    component: ListDelete,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'delete_incident_request:list'
    }
  },
  {
    path: '/incidents/delete/',
    name: 'DeleteIncident',
    component: Delete,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'delete_incident_request:bulk'
    }
  }
]
